import { render, staticRenderFns } from "./ParamGroupBarWidget.vue?vue&type=template&id=255e0ce8&scoped=true"
import script from "./ParamGroupBarWidget.vue?vue&type=script&lang=js"
export * from "./ParamGroupBarWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e0ce8",
  null
  
)

export default component.exports